import axios from 'axios';
import React, { useState, useRef, useMemo, useEffect } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Oval } from 'react-loader-spinner';
import {
    Box,
    Typography,
    Container,
} from '@mui/material';
import "../../styles/Admin-ui/Admin-PatientList.css";
import { API_DETAILS, COOKIE_KEYS, USER_TYPES } from '../../App';
import AdminSideBar from './Admin-SideBar';
import Youroheader from '../Youro-header';

import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

/**
 * When the account was created, in this admin's own time zone. Accounts made
 * before the column existed have no date: saying so is better than guessing
 * one from an appointment or a payment.
 */
const signedUpAt = (value) => {
  if (!value) return 'Not recorded';
  const when = new Date(value);
  if (Number.isNaN(when.getTime())) return 'Not recorded';
  return when.toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
};

const AdminPatientList = () => {
    const [tableDataPats, setTableDataPats] = useState([]);
    const [renderAdminPats, canRenderAdminPats] = useState(false);
    const [renderapidata, cannotrenderapidata] = useState(false);
    const isAdminPatsRendered = useRef(false);
    let count = 0;
    const [authContext, setAuthContext] = useState(''); // default zero. After login if ADMIN -> set('ADMIN') else if 'ASSITANT' -> set('ASSITANT')

    // The table used to be seeded with an array of made-up patients before the
    // real list arrived, so a slow or failed request showed fake names to an
    // admin as if they were real accounts.
    useEffect(() => {
        count += 1;
        if (!isAdminPatsRendered.current) {
            fetchData();
            isAdminPatsRendered.current = true;
        }
        else {
        }
    }, []);


    const fetchData = async () => {
        let type = USER_TYPES.user;
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllUsers/${type}`;
        Cookies.get(COOKIE_KEYS.userType) == 'ADMIN' ? setAuthContext('ADMIN') : (Cookies.get(COOKIE_KEYS.userType) == 'ASSITANT' ? setAuthContext('ASSITANT') : navigate('/login'))
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            canRenderAdminPats(true);
            setTableDataPats(res.data);
        }
        catch (err) {
            cannotrenderapidata(true);
        }
    };

    const columns = useMemo(
        () => [
            // {
            //     accessorKey: 'userId',
            //     header: 'ID',
            //     enableColumnOrdering: false,
            //     enableEditing: false,
            //     size: 50,
            // },
            {
                accessorKey: 'firstName',
                header: 'First Name',
            },
            {
                accessorKey: 'lastName',
                header: 'Last Name',
            },
            {
                accessorKey: 'email',
                header: 'Email',
            },
            {
                accessorKey: 'state',
                header: 'State',
            },
            {
                // The list was ordered by id and showed neither the address nor
                // the date, so a new signup appeared on whichever page of ten it
                // happened to land on and looked like nothing had happened.
                id: 'createdAt',
                header: 'Signed Up',
                // A Date, not the ISO string the API sends: the datetime sort
                // compares dates, and given strings it left the newest signup
                // wherever the server happened to return it.
                accessorFn: (row) => (row.createdAt ? new Date(row.createdAt) : null),
                Cell: ({ cell }) => signedUpAt(cell.getValue()),
                sortingFn: 'datetime',
                sortUndefined: 'last',
            },
        ],
        [],
    );

    const navigate = useNavigate();

    const handleClick = (row, context) => {
        if (context == 'VIEW_MORE') {
            navigate('/admin-view-patient', {
                state: {
                    userId: row.original.userId,
                    firstName: row.original.firstName,
                    lastName: row.original.lastName,
                    email: row.original.email,
                    phone1: row.original.phone1,
                    address: row.original.address,
                    city: row.original.city,
                    zipCode: row.original.zipCode,
                    createdAt: row.original.createdAt,
                    specialty: row.original.specialty,
                    status: row.original.status,
                    userType: row.original.userType,
                    state: row.original.state,
                    profileImageURL: row.original.profileImageURL,
                    license: row.original.license,
                    username: row.original.username,
                    gender: row.original.gender,
                    dateOfBirth: row.original.dateOfBirth
                }
            });
        }
        else if (context == 'CARE_PLAN') {
            navigate(`/doctor-view-profile/${row.original.userId}`);
        }
    };




    // if (!renderAdminPats) {
    //     return <div className="App">Loading...</div>;
    // }
    return (
        <div>
            {

                <div className='hm'>
                    <div className='sidebar'>
                        <AdminSideBar data={'admin-patients'} />
                    </div>
                    <div className="admin-ui-table">
                        {/* <div className='header'>
                                <h1 style={{marginLeft: '15px'}}>Youro</h1>
                            </div> */}
                        <div className='header' style={{ marginLeft: '15px' }}>
                            {/* <h1 style={{marginLeft: '15px'}}>youro</h1> */}
                            <Youroheader />
                        </div>
                        {renderAdminPats == true && tableDataPats && tableDataPats.length > 0 ? (
                            <MaterialReactTable
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        muiTableHeadCellProps: {
                                            align: 'center',
                                        },
                                        size: 120,
                                    },
                                }}
                                columns={columns}
                                data={tableDataPats}
                                // Newest first: an admin opening this screen is
                                // usually looking for the person who just joined.
                                initialState={{
                                    sorting: [{ id: 'createdAt', desc: true }],
                                    pagination: { pageIndex: 0, pageSize: 25 },
                                }}
                                enableColumnOrdering
                                muiTableContainerProps={{ sx: { maxHeight: window.innerHeight } }}
                                renderDetailPanel={({ row }) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            margin: 'auto',
                                            gridTemplateColumns: '1fr 1fr',
                                            width: '100%',
                                            padding: '0',
                                            maxWidth: '100%'
                                        }}
                                    >
                                        <Container maxWidth={false} sx={{ padding: '0', margin: '0px', maxWidth: '100%' }}>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <Typography>Signed up: {signedUpAt(row.original.createdAt)}</Typography>
                                                    <Typography>Email: {row.original.email}</Typography>
                                                    <Typography>Phone: {row.original.phone1 || '—'}</Typography>
                                                    <Typography>Address: {row.original.address}</Typography>
                                                    <Typography>City: {row.original.city}</Typography>
                                                    <Typography>State: {row.original.state}</Typography>
                                                    <Typography>Country: {row.original.country}</Typography>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12' style={{ textAlign: 'end' }}>
                                                    {/* <Link to={'/admin-view-patient' } className='view-more-class'>
                                                        View More{'>>'}
                                                        
                                                    </Link> */}
                                                    <button onClick={() => handleClick(row, 'CARE_PLAN')} className='view-more-class' >
                                                        View Care Plan {'>>'}
                                                    </button>
                                                    <button onClick={() => handleClick(row, 'VIEW_MORE')} className='view-more-class' >
                                                        View More {'>>'}
                                                    </button>
                                                    {/* <Link style={{ textDecoration: 'none' }} to={`/doctor-view-profile/${row.original.userId}`}></Link> */}
                                                    { }
                                                </div>
                                            </div>
                                        </Container>
                                    </Box>
                                )}
                                muiTableBodyProps={{
                                    sx: () => ({
                                        '& tr:nth-of-type(odd)': {
                                            backgroundColor: "lightgray",
                                        },
                                    }),
                                }}
                            />
                        ) : renderapidata ? (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh', }} >
                            We couldn't load this list. Refresh to try again.
                        </div>) : !renderAdminPats ? (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh', }} ><Oval /></div>) :
                            renderAdminPats == true && tableDataPats && tableDataPats.length == 0 && <>
                                <div style={{ textAlign: 'center', width: "98%", borderRadius: '10px', height: '70vh' }}>
                                    Nothing here yet.
                                </div>
                            </>
                        };
                    </div>
                </div>

                // </>
            }
        </div>
    );

};

export default AdminPatientList;
